/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY
// See angular/tools/gulp-tasks/cldr/extract.js

export default [
  [
    ['mn.', 'mg.', 'fm.', 'em.', 'kv.', 'nt.'],
    ['midn.', 'morg.', 'form.', 'etterm.', 'kveld', 'natt'],
    ['midnatt', 'morgenen', 'formiddagen', 'ettermiddagen', 'kvelden', 'natten']
  ],
  [
    ['mn.', 'mg.', 'fm.', 'em.', 'kv.', 'nt.'],
    ['midn.', 'morg.', 'form.', 'etterm.', 'kveld', 'natt'],
    ['midnatt', 'morgen', 'formiddag', 'ettermiddag', 'kveld', 'natt']
  ],
  [
    '00:00', ['06:00', '10:00'], ['10:00', '12:00'], ['12:00', '18:00'], ['18:00', '24:00'],
    ['00:00', '06:00']
  ]
];
